// extracted by mini-css-extract-plugin
export var container = "styles-module__container___WATWE";
export var icon = "styles-module__icon___rzysA";
export var text = "styles-module__text___jcSGG";
export var title = "styles-module__title___DtSo1";